import React, { createContext } from 'react';

interface AgileContextValue {
  enableZoneListInHeader: boolean;
  setEnableZoneListInHeader: React.Dispatch<React.SetStateAction<boolean>>;
}

const initialValue: AgileContextValue = {
  enableZoneListInHeader: true,
  setEnableZoneListInHeader: () => {},
};

const AgileContext = createContext<AgileContextValue>(initialValue);
export default AgileContext;
